/**
 * The redesign's vendor mark (guide §3): the system's letter on its brand square. Decorative — the system's
 * name always appears as text next to it, so the mark is `aria-hidden`. Brand colours are identical in both
 * themes (`--color-vendor-*`).
 */
const LETTERS: Readonly<Record<string, string>> = {
  xero: "X",
  lucibook: "L",
  qbo: "Q",
  freeagent: "F",
  sage_bc: "S",
  hmrc: "H",
};

const COLOURS: Readonly<Record<string, string>> = {
  xero: "xero",
  lucibook: "lucibook",
  qbo: "qbo",
  freeagent: "freeagent",
  sage_bc: "sagebc",
  hmrc: "other",
};

export function VendorMark({
  system,
  size = 28,
}: {
  /** The API's system code (`xero`, `lucibook`, `qbo`, `freeagent`, `sage_bc`, `hmrc`, …). */
  system: string;
  /** 22 in tables, 24 in the new-migration summary bar, 28 in lists, 32 in pickers, 40 in the return pages' chrome, 44 on connector cards (§3 + static HTML). */
  size?: 22 | 24 | 28 | 32 | 40 | 44;
}): JSX.Element {
  const key = system.toLowerCase();
  const letter = LETTERS[key] ?? (key.slice(0, 1).toUpperCase() || "?");
  const colour = COLOURS[key] ?? "other";
  return (
    <span className={`vmark vmark--${size} vmark--${colour}`} aria-hidden="true">
      {letter}
    </span>
  );
}
